import React from 'react'

const Point = ( props ) => {
    return (
        <div style={{ width: '50px' }} >
            <div className='pinfix' style={{ background: props.colore}} >
                <img className="uk-border-circle" width="50" height="50" src={props.immagine} data-uk-tooltip={props.nome} />
            </div>
            <div className='pulse'></div>
        </div>
    )
}

export default Point


// WEBPACK FOOTER //
// ./src/components/sito/temi/layoutorizzontale/utilities/point/index.js